import { __decorate } from "tslib";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
import Datepicker from "vuejs-datepicker";
import EmployeeCollectionAdmin from "@/classes/EmployeeCollectionAdmin";
import TeamList from "@/types/Team/TeamList";
import TeamMemberList from "@/types/Team/TeamMemberList";
import UserList from "@/types/User/UserList";
let Teams = class Teams extends Vue {
    isCurrentEmployee(date) {
        return moment(new Date()) <= moment(date) || date === null;
    }
    loadTeamMembers() {
        this.$data.loadingTeamMembers = true;
        this.$store
            .dispatch("adminLoadTeamMembersAsync", this.$data.selectedTeamData)
            .then((result) => {
            this.$data.selectedTeamMembers = new TeamMemberList(result.data);
            this.$data.loadingTeamMembers = false;
        })
            .catch((err) => {
            this.$data.loadingTeamMembers = false;
            window.errorHandler.logError(err, "Admin/Teams.vue -> loadTeamMembers");
        });
    }
    loadUsers() {
        this.$data.loading = true;
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            this.$data.userList = new UserList(result.data);
            this.$data.loading = false;
        })
            .catch((err) => {
            this.$data.loading = false;
            window.errorHandler.logError(err, "Admin/Teams.vue -> loadUsers");
        });
    }
    loadTeams() {
        this.$data.loading = true;
        this.$store
            .dispatch("adminLoadTeamsAsync")
            .then((result) => {
            this.$data.teamList = new TeamList(result.data);
            this.$data.loading = false;
        })
            .catch((err) => {
            this.$data.loading = false;
            window.errorHandler.logError(err, "Admin/Teams.vue -> loadTeams");
        });
    }
    updateTeam() {
        this.$data.loading = true;
        this.$data.selectedTeamData.directorId = this.$data.selectedTeamDirector.id;
        this.$data.selectedTeamData.teamManagerId =
            this.$data.selectedTeamManager.id;
        this.$store
            .dispatch("adminUpdateTeamAsync", this.$data.selectedTeamData)
            .then((result) => {
            this.loadTeams();
            this.$data.modals.editTeam = false;
            this.$data.loading = false;
            //cleanup
            this.$data.selectedTeamManager = null;
            this.$data.selectedTeamDirector = null;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Admin/Teams.vue -> updateTeam");
            this.$data.loading = false;
        });
    }
    deleteMemberModal(item) {
        this.$data.selectedEmployeeToRemove = item;
        this.$data.modals.deleteMember = true;
    }
    // add the user to the team
    addTeamMember() {
        if (!this.$data.selectedEmployeeToAdd.from) {
            this.$data.selectedEmployeeToAdd.from = new Date();
        }
        if (!this.$data.selectedEmployeeToAdd.to) {
            this.$data.selectedEmployeeToAdd.to = null;
        }
        this.$store
            .dispatch("adminAddTeamMemberAsync", {
            teamId: this.$data.selectedTeamData.id,
            member: this.$data.selectedEmployeeToAdd,
        })
            .then((result) => {
            //this.loadTeams();
            this.loadTeamMembers();
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Admin/Teams.vue -> addTeamMember");
        });
        this.$data.modals.addMember = false;
    }
    isActiveTeam(toDate) {
        if (toDate === null) {
            return true;
        }
        else {
            return false;
        }
    }
    editTeam(team) {
        this.$data.selectedTabEditTeam = 0;
        this.$data.modals.editTeam = true;
        this.$data.selectedTeamData = team;
        this.$data.selectedTeamManager = this.$data.userList.getUser(team.teamManagerId)[0];
        this.$data.selectedTeamDirector = this.$data.userList.getUser(team.directorId)[0];
    }
    // loads the employees as an admin
    preLoading() {
        this.$store
            .dispatch("adminLoadEmployees")
            .then((result) => {
            this.$data.employees = new EmployeeCollectionAdmin(result.data);
            //load the teams when we have the employees
            this.$store
                .dispatch("adminLoadTeamsAsync")
                .then((result2) => {
                this.$data.teams = result2.data;
                this.$data.preloaded = true;
            })
                .catch((err) => {
                window.errorHandler.logError(err, "Admin/Teams.vue -> preLoading -> adminLoadTeamsAsync ");
                this.$data.preloaded = true;
            });
        })
            .catch((err) => {
            this.$data.preloaded = true;
            window.errorHandler.logError(err, "Admin/Teams.vue - preLoading -> adminLoadEmployees");
        });
    }
    /*private loadTeams(){
      this.$data.loading = true;
      this.$store.dispatch('adminLoadTeamsAsync').then((result:any) =>{
        this.$data.teams = result.data;
        this.$data.loading = false;
      }).catch((err: any) => {
        (window as any).errorHandler.logError(err, 'Admin/Teams.vue -> loadTeams');
        this.$data.loading = false;
      })
    }*/
    selectTeamStartDate() {
        this.$data.selectedTeamData.from = moment(this.$data.selectedTeamData.from).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
    selectTeamEndDate() {
        this.$data.selectedTeamData.to = moment(this.$data.selectedTeamData.to).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
    selectMemberStartDate() {
        this.$data.selectedEmployeeToAdd.from = moment(this.$data.selectedEmployeeToAdd.from).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
    selectMemberEndDate() {
        this.$data.selectedEmployeeToAdd.to = moment(this.$data.selectedEmployeeToAdd.to).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
    selectCreateTeamStartDate() {
        this.$data.createTeamFromDate = moment(this.$data.createTeamFromDate).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
    editTeamMemberDialog(selectedMember) {
        const selectedTeamId = this.$data.selectedTeamData.id;
        this.$data.selectedEmployeeToAdd = selectedMember;
        this.$data.modals.editMemberTimes = true;
    }
    // updates the from and to for a team member
    updateTeamMember() {
        const selectedTeamId = this.$data.selectedTeamData.id;
        this.$store
            .dispatch("adminUpdateTeamMemberAsync", {
            teamId: this.$data.selectedTeamData.id,
            member: this.$data.selectedEmployeeToAdd,
        })
            .then((result) => {
            this.loadTeams();
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Admin/Teams.vue -> updateTeamMember");
        });
        this.$data.modals.editMemberTimes = false;
    }
    removeTeamMember(selectedMember) {
        const selectedTeamId = this.$data.selectedTeamData.id;
        selectedMember = this.$data.selectedEmployeeToRemove;
        this.$store
            .dispatch("adminRemoveTeamMemberAsync", {
            teamId: this.$data.selectedTeamData.id,
            member: selectedMember,
        })
            .then((result) => {
            // this.loadTeams();
            this.loadTeamMembers();
            this.$data.selectedEmployeeToRemove = null;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Admin/Teams.vue -> removeTeamMember");
        });
    }
    addTeamMemberDialog() {
        this.$data.selectedEmployeeToAdd = null;
        this.$data.modals.addMember = true;
    }
    createTeam() {
        this.$store
            .dispatch("adminCreateTeamAsync", {
            name: this.$data.createTeamName,
            teamManagerId: this.$data.selectedTeamManager.id,
            directorId: this.$data.selectedTeamDirector.id,
            from: this.$data.createTeamFromDate,
        })
            .then((result) => {
            this.loadTeams();
            this.$data.modals.createTeam = false;
            //cleanup
            this.$data.selectedTeamManager = null;
            this.$data.selectedTeamDirector = null;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Admin/Teams.vue -> createTeam");
        });
    }
    removeTeamDialog(team) {
        this.$data.selectedTeamData = team;
        this.$data.modals.confirmDeleteTeam = true;
    }
    RemoveTeam() {
        this.$store
            .dispatch("adminRemoveTeamAsync", {
            teamId: this.$data.selectedTeamData.id,
        })
            .then((result) => {
            this.loadTeams();
            this.$data.modals.confirmDeleteTeam = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Admin/Teams.vue -> RemoveTeam");
        });
    }
};
Teams = __decorate([
    Component({
        data() {
            return {
                theme: this.$store.getters.getTheme,
                teams: null,
                teamHeaders: [
                    { text: "Name", value: "name" },
                    { text: "Manager ", value: "teamManagerFirstName" },
                    // { text: "", value: "teamManagerLastName" },
                    { text: "Active", value: "active", sortable: false },
                    { text: "", value: "edit" },
                    { text: "", value: "delete" },
                ],
                teamMembersHeaders: [
                    { text: "Name", value: "name" },
                    { text: "From", value: "from" },
                    { text: "To", value: "to" },
                    { text: "", value: "edit" },
                    { text: "", value: "delete" },
                ],
                filter: "",
                createTeamName: "",
                selectedTeamManager: null,
                selectedTeamDirector: null,
                selectedEmployeeToAdd: null,
                selectedEmployeeToRemove: null,
                modals: {
                    editTeam: false,
                    addMember: false,
                    deleteMember: false,
                    createTeam: false,
                    confirmDeleteTeam: false,
                    editMemberTimes: false,
                },
                selectedTeamData: null,
                employees: null,
                preloaded: true,
                loading: false,
                loadingTeamMembers: false,
                teamList: null,
                userList: null,
                selectedTeamMembers: null,
                selectedTabEditTeam: 0,
                createTeamFromDate: null,
                showAllTeams: false,
                currentOnly: true, //switch property to hide disabled items
            };
        },
        computed: {
            filteredTeamMembers() {
                const members = this.$data.selectedTeamMembers.teamMembers;
                if (this.$data.currentOnly) {
                    return members.filter((member) => this.isCurrentEmployee(member.to));
                }
                return members;
            },
            filteredTeams() {
                if (!this.$data.teamList) {
                    return null;
                }
                const allTeams = { ...this.$data.teamList };
                if (!this.$data.showAllTeams) {
                    allTeams.teams = allTeams.teams.filter((team) => this.isActiveTeam(team.to));
                }
                return allTeams;
            },
        },
        mounted() {
            this.loadUsers();
            this.loadTeams();
            //this.preLoading();
            //this.$store.dispatch("getEmployeesAdmin");
            // loading the employee list
            /*(window as any).eventBus.$on('employeesAdminLoaded', (obj: any) => {
              const emps = obj.filter((object: any) => (object.endOfEmployment === undefined || object.endOfEmployment === null));
             this.$data.employees = emps;
            });*/
        },
        components: {
            IconBox,
            IconBoxContent,
            Datepicker,
            DatePickerTextbox,
        },
    })
], Teams);
export default Teams;
